import { ErrorToastType } from '../../../components/popup/types';
import { ApiMask, updateApiMask } from '../../../logger/BitMask';
import { Logger } from '../../../logger/Logger';
import { betActions } from '../../../store/slices/bets/slice';
import type { IBetSpots } from '../../../store/slices/bets/types';
import { gameStateActions } from '../../../store/slices/game/slice';
import { GameStatus } from '../../../store/slices/game/types';
import { toastActions } from '../../../store/slices/toast/slice';
import type { GameCommunicationMessageType } from '../types';
import { MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

interface SubscribeMessage extends GameCommunicationMessageType {
  channel?: string;
}

export class CoreSubscribeGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.Subscribe;

  public process(message: SubscribeMessage): void {
    const gameChannel = message?.channel;
    if (gameChannel) {
      this.store.dispatch(gameStateActions.setGameChannel(gameChannel));
      updateApiMask(ApiMask.GameSocket);
    } else {
      Logger.logFailure('GameSocket', {
        place: 'Subscribe',
        additional: 'No game channel in message:' + message,
      });
    }

    // WHY HERE? It is not related to the subscribe message,
    // however it is only reliable place (all initial socket messages received, so we can check bets here)
    this.checkBets();
  }

  // HACK: This is a temporary solution to sync placed bets with accepted (until we will get bets with single message from the server always)
  private checkBets(): void {
    const bets = this.store.getState().bets;
    const acceptedBets = bets.acceptedBets;
    const betStack = bets.betStack;
    const betStackHead = betStack[betStack.length - 1]?.betSpots;

    if (!acceptedBets || !betStackHead) {
      return;
    }

    const hasUnacceptedBets = Object.keys(betStackHead).some((key) => {
      return (
        betStackHead[key]!.value !== 0 &&
        !acceptedBets.find((bet) => bet.betCode === Number(key) && bet.amount === betStackHead[key]!.value)
      );
    });

    if (hasUnacceptedBets && acceptedBets.length > 0) {
      // Show bets rejected toast
      this.store.dispatch(toastActions.createToast(ErrorToastType.NOT_ALL_BETS_ACCEPTED));
      // Change game status
      this.store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.NotAllBetsAccepted));

      // Make betType object from acceptedBets
      const acceptedBetStack = {
        betSpots: acceptedBets.reduce((prev, current) => {
          prev[current.betCode] = { value: current.amount };
          return prev;
        }, {} as IBetSpots),
      };

      this.store.dispatch(betActions.overrideBetStack([acceptedBetStack]));
    } else if (hasUnacceptedBets && acceptedBets.length === 0) {
      this.store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.BetsRejected));
    }
  }
}
